import { createFileRoute } from '@tanstack/react-router';

import {
    documentParams,
    documentSearchSchema,
} from '@/features/Transition360/DocumentViewer/documentRouteParams';
import { ProjectDocumentPage } from '@/features/Transition360/ProjectDocumentPage';

/**
 * One T360 document in the viewer.
 *
 * `page` is 1-based within the document, so 1 is the document's own first page.
 * A caller holding a page of the source file, such as a status-report row's
 * evidence, passes `file_page - start_page + 1`. `q` turns on the marks for
 * that text on each page.
 */
export const Route = createFileRoute(
    '/transition-360/projects/$projectId/documents/$documentId',
)({
    params: documentParams,
    validateSearch: documentSearchSchema,
    component: DocumentRoute,
});

function DocumentRoute() {
    const { projectId, documentId } = Route.useParams();
    const { page, q } = Route.useSearch();
    return (
        <ProjectDocumentPage
            projectId={projectId}
            documentId={documentId}
            page={page}
            searchText={q}
        />
    );
}
